export abstract class BaseExpression {
  id: string
  name: string
  constructor() {}
  public abstract evaluateExpression(config?: any, options?:any): any;
  public abstract getExpressionDetail(): any
}
